import React from 'react';
import SystemAlertService from '../Services/SystemAlertService';
import ErrorMessage from './ErrorMessage';

class SystemAlertPopup extends React.Component
{
  constructor (props)
  {
    super(props);
    this.state = {
      result: 0,
    };
  }

  componentDidMount ()
  {
    this.populateData();
  }

  populateData ()
  {
    SystemAlertService.GetSystemAlertForPopup()
      .then((result) =>
      {
        if (result)
        {
          ErrorMessage.SetWarning(`${result.title} - ${result.message}`);
        }
        this.setState({ result: result.result });
        if (ErrorMessage.EveryWhere()) window.setTimeout(() => this.populateData(), 600000);
      })
      .catch((error) => window.setTimeout(() => this.populateData(), 600000));
  }

  render ()
  {
    return null;
  }
}

export default SystemAlertPopup;
